/**
 * Les adresses propres au module **catalogue**.
 *
 * ★ Elles vivent ici et non dans `lib/chemins.ts` pour la même raison que
 * `CHEMIN_APPARENCE` : `lib/` appartient à la fondation, et plusieurs lots y
 * écrivent en même temps. Le routeur, lui, n'a rien à apprendre — il monte
 * `routesCatalogue` sous `/admin/catalogue`, et le segment ci-dessous en est un
 * enfant.
 */

import { CHEMINS } from '../../lib/chemins'

/** Le motif de route de la fiche d'un spectacle, monté par `routesCatalogue`. */
export const SEGMENT_SPECTACLE = ':saisonId/spectacles/:spectacleId'

function avecRecherche(base: string, recherche: string): string {
  return recherche === '' ? base : `${base}?${recherche.replace(/^\?/u, '')}`
}

/**
 * La fiche d'un spectacle : `/admin/catalogue/<saison>/spectacles/<spectacle>`.
 *
 * ★ Elle emporte la chaîne de requête de la liste d'où l'on vient (la page
 * affichée), pour que le lien de retour repose l'utilisateur SUR SA PAGE. Sans
 * cela, paginer une liste et y ouvrir une fiche se contrediraient : on gagnerait
 * une liste qui tient à l'écran pour perdre sa position à chaque clic.
 */
export function cheminSpectacle(saisonId: string, spectacleId: string, recherche = ''): string {
  return avecRecherche(`${CHEMINS.catalogue}/${saisonId}/spectacles/${spectacleId}`, recherche)
}

/** Le retour à la saison, dans l'état exact où on l'avait laissée. */
export function cheminSaison(saisonId: string, recherche = ''): string {
  return avecRecherche(`${CHEMINS.catalogue}/${saisonId}`, recherche)
}
